import React, { useEffect, useState, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import BackButtonComponent from "../../components/BackButtonComponent/BackButtonComponent";
import {
  COUNTRIES_BY_CLIENT,
  ALL_MY_SPACES_BY_ID,
} from "../../GraphQL/Queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import { clientWellness } from "../../App";
import { uploadFile, getFile } from "../../services/FileManager";
import { CREATE_SPACE, UPDATE_SPACE } from "../../GraphQL/Mutations";
import { NotificationManager } from "react-notifications";
import CreateSpaceComponent from "../../components/CreateSpaceComponent";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import moment from "moment";

const CreateSpaceContainer = () => {
  const location = useLocation();
  const [user] = useState(getStateLoginComplete());
  const [clientId] = useState(user.clientId);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [countryId, setCountryId] = useState();
  const history = useHistory();
  const action = location?.state?.myspace ? "edit" : "add";
  const [files, setFiles] = useState({});
  const [myspace, setMySpace] = useState();
  const [createSpace] = useMutation(CREATE_SPACE, { client: clientWellness });
  const [updateSpace] = useMutation(UPDATE_SPACE, { client: clientWellness });
  const [loadingCoverImage, setLoadingCoverImage] = useState(false);
  const [fileName, setFileName] = useState();
  const [dataSpace, setDataSpace] = useState();
  const [usersRegistered, setUsersRegistered] = useState();
  const [groupRegistered, setGroupRegistered] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [cityRender, setCityRender] = useState(false);
  const rCity = useRef();

  const [runQueryCountryByClient] = useLazyQuery(COUNTRIES_BY_CLIENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllCountries = data?.countryLocationList?.map((element) => {
        return {
          ...element,
          value: element?.countryId,
          label: element?.countryName,
        };
      });
      setCountries(resultOfAllCountries);
    },
  });

  const [runQueryAllMySpacesById] = useLazyQuery(ALL_MY_SPACES_BY_ID, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.spaceById) {
        setMySpace(data?.spaceById);
      }
    },
  });

  const getCityForCountry = (id) => {
    let selectedCountry = countries.filter((e) => e.countryId === parseInt(id));
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          value: e.cityId,
          label: e.cityName,
        };
      });
      setCities(citiesArr);
    } else {
      setCities([]);
    }
  };

  useEffect(() => {
    if (myspace && !cityRender) {
      setCityRender(true);
    }
  }, [cities]);

  useEffect(() => {
    if (cityRender && myspace) {
      rCity.current.state.ariaSelection = {
        value: myspace.idCity,
        label: myspace.cityName,
      };
      rCity.current.state.selectValue = [
        {
          value: myspace.idCity,
          label: myspace.cityName,
        },
      ];
    }
  }, [cityRender]);

  useEffect(() => {
    if (clientId) {
      runQueryCountryByClient({
        variables: { clientId: clientId },
        context: { clientName: "LinkUsers" },
      });
    }
    if (countryId) {
      getCityForCountry(countryId);
    }
  }, [user, clientId, countryId]);

  useEffect(() => {
    if (location?.state?.myspace) {
      runQueryAllMySpacesById({
        variables: { idSpace: location?.state?.myspace?.idSpace },
      });
    }
  }, [location?.state?.myspace]);

  useEffect(() => {
    if (myspace && countries.length > 0 && !cityRender) {
      getCityForCountry(myspace?.idCountry);
    }
  }, [countries, myspace]);

  useEffect(() => {
    if (myspace?.coverImageSrc) {
      setLoadingCoverImage(true);
      getFile(myspace?.coverImageSrc)
        .then((response) => {
          try {
            response.lastModifiedDate = new Date();
            response.name = myspace?.coverImageSrc;
            const myFile = new File([response], myspace?.coverImageSrc, {
              type: response.type,
            });
            setFiles({ file: myFile });
            setLoadingCoverImage(false);
          } catch (error) {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
            setLoadingCoverImage(false);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setLoadingCoverImage(false);
        });
    }
  }, [myspace]);

  useEffect(() => {
    if (
      (action === "add" && fileName) ||
      (action === "add" && fileName === "")
    ) {
      handleCreateSpace();
    }

    if (
      (action === "edit" && fileName) ||
      (action === "edit" && fileName === "")
    ) {
      handleUploadSpace();
    }
  }, [fileName, dataSpace]);

  let goToBackPage = () => {
    history.push({ pathname: "/SpacesManagement" });
  };

  let handleUploadSpace = () => {
    setShowLoader(true);
    if (moment(dataSpace?.finishDate).isAfter(moment(dataSpace?.startDate))) {
      updateSpace({
        variables: {
          idSpace: myspace?.idSpace,
          name: dataSpace?.name,
          description: dataSpace?.description,
          coverImageSrc: fileName ? fileName : "",
          topic: dataSpace?.topic,
          startDate: new Date(dataSpace?.startDate).toUTCString(),
          finishDate: new Date(dataSpace?.finishDate).toUTCString(),
          url: dataSpace?.url,
          idCity: dataSpace?.city?.value?.value,
          usersRegistered: usersRegistered,
          groupRegistered: groupRegistered,
        },
      })
        .then((response) => {
          if (response.errors) {
            NotificationManager.error(response.errors[0].message, "", 5000);
          } else {
            if (response.data.updateSpace.idSpace > 0) {
              NotificationManager.success(
                "The space is successfully updated",
                "",
                5000
              );
              goToBackPage();
            } else NotificationManager.warning("Update space failed", "", 5000);
          }
          setShowLoader(false);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setShowLoader(false);
        });
    } else {
      NotificationManager.error(
        "End Date must be greater than the Start Date",
        "",
        5000
      );
      setShowLoader(false);
    }
  };

  let handleCreateSpace = () => {
    if (moment(dataSpace?.finishDate).isAfter(moment(dataSpace?.startDate))) {
      createSpace({
        variables: {
          name: dataSpace?.name,
          description: dataSpace?.description,
          coverImageSrc: fileName ? fileName : "",
          topic: dataSpace?.topic,
          startDate: new Date(dataSpace?.startDate).toUTCString(),
          finishDate: new Date(dataSpace?.finishDate).toUTCString(),
          url: dataSpace?.url,
          idCity: dataSpace?.city?.value?.value,
          usersRegistered: usersRegistered,
          groupRegistered: groupRegistered,
        },
      })
        .then((response) => {
          if (response.data.createSpace.idSpace > 0) {
            NotificationManager.success(
              "The space is successfully created",
              "",
              5000
            );
            goToBackPage();
          } else NotificationManager.warning("Create space failed", "", 5000);
          setShowLoader(false);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setShowLoader(false);
        });
    } else {
      NotificationManager.error(
        "End Date must be greater than the Start Date",
        "",
        5000
      );
      setShowLoader(false);
    }
  };

  let createNew = (data, groupsSelected, usersSelected, folderName) => {
    setShowLoader(true);
    setUsersRegistered(
      usersSelected.map((item) => {
        if (item.userId) {
          return {
            userId: item.userId,
            userName: item.name,
          };
        } else if (item.ccmsuser) {
          return {
            userId: item.value,
            userName: item.ccmsuser,
          };
        }
      })
    );
    setGroupRegistered(
      groupsSelected.map((item) => {
        if (item.isGroup) {
          return {
            usersInGroup: [item.userId],
            groupName: item.name,
          };
        } else if (item.userIds) {
          return {
            usersInGroup: [...item.userIds],
            groupName: item.groupName,
          };
        }
      })
    );
    if (data && new Date(data.startDate) > new Date()) {
      if (data.file) {
        uploadFile([data.file], folderName)
          .then((imageName) => {
            let arrayNames = JSON.parse(imageName);
            setFileName(arrayNames[0].newName);
            setShowLoader(false);
          })
          .catch((error) => {
            setShowLoader(false);

            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
          });
      } else {
        setShowLoader(false);
        setFileName("");
      }
      setDataSpace(data);
    } else {
      NotificationManager.warning(
        "The date must be greater than the current date",
        "",
        5000
      );
      setShowLoader(false);
    }
  };

  let updateOld = (data, groupsSelected, usersSelected, folderName) => {
    setShowLoader(true);
    setUsersRegistered(
      usersSelected.map((item) => {
        if (item.userId) {
          return {
            userId: item.userId,
            userName: item.name,
          };
        }
        if (item.ccmsuser) {
          return {
            userId: item.value,
            userName: item.ccmsuser,
          };
        }
      })
    );
    setGroupRegistered(
      groupsSelected.map((item) => {
        if (item.isGroup) {
          return {
            usersInGroup: [item.userId],
            groupName: item.name,
          };
        } else if (item.userIds) {
          return {
            usersInGroup: [...item.userIds],
            groupName: item.groupName,
          };
        }
      })
    );
    if (myspace && data && new Date(data.startDate) > new Date()) {
      if (data?.file?.name?.indexOf("/") === -1) {
        uploadFile([data.file], folderName)
          .then((imageName) => {
            let arrayNames = JSON.parse(imageName);
            setFileName(arrayNames[0].newName);
            setShowLoader(false);
          })
          .catch((error) => {
            setShowLoader(false);
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
          });
      } else if (data?.file) {
        if (data.file.name.indexOf("/") !== -1) {
          setFileName(data.file.name);
        }
        setShowLoader(false);
      } else {
        setFileName("");
        setShowLoader(false);
      }
      setDataSpace(data);
    } else {
      NotificationManager.warning(
        "The date must be greater than the current date",
        "",
        5000
      );
      setShowLoader(false);
    }
  };

  return (
    <>
      <BackButtonComponent
        backtitle={"Spaces Management"}
        locationtitle={action === "add" ? "New Space" : myspace?.name}
        goToBackPage={goToBackPage}
        identity={"createSpace"}
      />
      <CreateSpaceComponent
        files={files}
        setFiles={setFiles}
        loadingCoverImage={loadingCoverImage}
        SpaceEdit={myspace}
        createNew={createNew}
        updateOld={updateOld}
        action={action}
        goToBackPage={goToBackPage}
        setCountryId={setCountryId}
        countries={countries}
        cities={cities}
        rCity={rCity}
      />
      {showLoader && <ModalLoader />}
    </>
  );
};

export default CreateSpaceContainer;
